import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface CreateHashtagData {
  name: string
  contactAccountIds: string[]
}

const createHashtag = async (data: CreateHashtagData): Promise<string> => {
  const { data: responseData } = await api.post<string>('/hashtag', data)
  return responseData
}

export const useCreateHashtag = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<string, Error, CreateHashtagData>({
    mutationFn: createHashtag,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.hashtagCreated'))
      await queryClient.invalidateQueries({ queryKey: ['hashtags'] })
    },
  })
}

